const ratingHeight = () =>  {
  setTimeout(() => {
    let cacheHeight = 0;
    let ele = document.querySelectorAll('.product-thumbnail__title');
    if(ele){
      ele.forEach(element => {
        (element.clientHeight > cacheHeight) ? cacheHeight = element.clientHeight : cacheHeight = cacheHeight;
      });
      ele.forEach(element => {
        element.style.height = `${cacheHeight}px`
      })
    }
  },500);
 }

document.addEventListener('DOMContentLoaded', function () {
  ratingHeight();
});